import { createAction } from 'redux-actions';
import { CheckinOrderFragment } from '@websky/graphql';

export const FILL_CHECKIN_ORDER = 'FILL_CHECKIN_ORDER';
export const SET_CHECKIN_ORDER = 'SET_CHECKIN_ORDER';

export const setCheckinOrder = createAction<CheckinOrderFragment>(SET_CHECKIN_ORDER);
export const fillCheckinOrder = createAction<CheckinOrderFragment>(FILL_CHECKIN_ORDER);
